module.exports = __webpack_public_path__ + "img/ap32-register-bg-mb.e3d8e786.png";